/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExternalFoldersCard_folders = {
    readonly nodes: ReadonlyArray<{
        readonly slug: string;
        readonly activeTicket: string;
        readonly parentType: string;
        readonly " $fragmentRefs": FragmentRefs<"ExternalFolder_folder">;
    } | null> | null;
    readonly " $refType": "ExternalFoldersCard_folders";
};
export type ExternalFoldersCard_folders$data = ExternalFoldersCard_folders;
export type ExternalFoldersCard_folders$key = {
    readonly " $data"?: ExternalFoldersCard_folders$data;
    readonly " $fragmentRefs": FragmentRefs<"ExternalFoldersCard_folders">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalFoldersCard_folders",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Folder",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activeTicket",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parentType",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ExternalFolder_folder"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FolderConnection",
  "abstractKey": null
};
(node as any).hash = '0ce7a498dd04b0f11da830876956f946';
export default node;
